import script from "./ProductModalCreators.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductModalCreators.vue?vue&type=script&setup=true&lang=js"

import "./ProductModalCreators.vue?vue&type=style&index=0&id=1edd831f&lang=scss"

const __exports__ = script;

export default __exports__